'use strict'

import 'jquery'
import { isIE } from './utils/isIE'
import { breakpointUp } from './utils/breakpoints'

if(!isIE()) {

  require('./setup')
  require('./sections/news')
  require('./popup-manager')
  require('./accordion')
  require('./cursor')
  require('./skew-on-scroll')
  require('./split-text')
  require('./cookies')
  require('./layout/header.js')
  require('./sections/hero-sequence')
  require('./sections/jury')
  require('./language-switcher')

  require('./sections/categories-sequence')

  require('./lazy-load')

  if($('.smooth-scroll').length){
    if(breakpointUp('lg')) {
      require('./loco-scroll')
    } else {
      require('./scroll')
    }
  }

} else {
  let noIE = $('#no-IE-support').html()
  $('body').html(noIE)
}



